import getUrlParams from './getUrlParams'

export default function () {
  return Number(getUrlParams('test')) === 1
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isTest.js